// Cloudscape dark/light mode toggle. Persists choice in localStorage so the
// app boots into the user's preference. Applies on import for first paint.
import { applyMode, Mode } from "@cloudscape-design/global-styles";

const STORAGE_KEY = "soc1lab-v3-theme";

export type ThemeMode = "light" | "dark";

export function getStoredTheme(): ThemeMode {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === "dark" ? "dark" : "light";
}

export function setTheme(mode: ThemeMode): void {
  localStorage.setItem(STORAGE_KEY, mode);
  applyMode(mode === "dark" ? Mode.Dark : Mode.Light);
}

export function initTheme(): ThemeMode {
  const mode = getStoredTheme();
  applyMode(mode === "dark" ? Mode.Dark : Mode.Light);
  return mode;
}
